import { buildForm, toast } from "@bleu.builders/ui";
import { serialize } from "object-to-formdata";
import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useActionData, useLoaderData, useSubmit } from "react-router-dom";
import { Wizard } from "react-use-wizard";

import { getObjectsDifference } from "#/lib/objectDifference";

import { Step } from "./Step";
import { WizardFormWrapper } from "./Wrapper";

export const WizardForm = ({ mode = "create" }) => {
  // @ts-ignore
  const { data } = useLoaderData();
  const steps = data.steps;
  const defaultValues = data.defaultValues;
  const submit = useSubmit();

  const actionData = useActionData() as {
    data: { errors: object; success: boolean };
  };

  const form = useForm({
    mode: "all",
    defaultValues,
    errors: actionData?.data?.errors,
  });

  const handleSubmit = async () => {
    const isValid = await form.trigger();
    if (!isValid) return;

    // if the mode is "update", we only send the changed values
    const values =
      mode === "create"
        ? form.getValues()
        : getObjectsDifference(defaultValues, form.getValues());
    if (Object.keys(values).length === 0) {
      toast({
        title: "Nenhuma alteração detectada",
        description: "Por favor, faça alguma alteração para salvar.",
        variant: "destructive",
      });
      return;
    }
    const formData = serialize(values, { allowEmptyArrays: true });

    submit(formData, {
      method: "post",
      encType: "multipart/form-data",
    });
  };

  const formValues = form.formState;

  const stepsFormElements = useMemo(() => {
    return steps
      .map((step, idx) => {
        const formElements = buildForm(step.fields, form);

        if (formElements.length === 0) return null;

        return (
          <Step
            key={`step-${idx}`}
            handleSubmit={handleSubmit}
            form={form}
            mode={mode}
          >
            <div className="flex flex-col gap-5 p-5">{formElements}</div>
          </Step>
        );
      })
      .filter((step) => step !== null);
  }, [steps, formValues]);

  return (
    <div className="flex w-full items-center justify-center py-2">
      <Wizard
        wrapper={
          // @ts-expect-error TS(2741) FIXME: Property 'children' is missing in type '{ steps: a... Remove this comment to see the full error message
          <WizardFormWrapper steps={steps} form={form} />
        }
        startIndex={0}
      >
        {stepsFormElements}
      </Wizard>
    </div>
  );
};
